(function() {
  'use strict';

  async function updateCart(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    });
    return res.json();
  }

  async function refreshCartTotals(cart) {
    // Update bill totals
    const fmt = (cents) => 'Rs. ' + (cents / 100).toFixed(2);

    // Update all subtotals per item
    document.querySelectorAll('.fcp-item').forEach(function(itemEl) {
      const key = itemEl.dataset.key;
      const cartItem = cart.items.find(i => i.key === key);
      if (!cartItem) {
        // Item removed — fade out and remove
        itemEl.style.transition = 'opacity 0.3s';
        itemEl.style.opacity = '0';
        setTimeout(() => itemEl.remove(), 300);
        return;
      }
      // Update subtotal
      const subtotalEl = itemEl.querySelector('.fcp-item__subtotal strong');
      if (subtotalEl) subtotalEl.textContent = fmt(cartItem.line_price);

      // Update qty display
      const qtyEl = itemEl.querySelector('.fcp-stepper__qty');
      if (qtyEl) qtyEl.textContent = cartItem.quantity;
    });

    // Update bill grand total
    document.querySelectorAll('.fcp-bill__row--total span:last-child').forEach(el => {
      el.textContent = fmt(cart.total_price);
    });
    document.querySelectorAll('.fcp-checkout-btn__left').forEach(el => {
      el.textContent = fmt(cart.total_price);
    });

    // Update min order banner
    const minBanner = document.querySelector('.fcp-min-banner');
    if (minBanner) {
      const MIN = 89900;
      if (cart.total_price >= MIN) {
        minBanner.classList.add('fcp-min-banner--met');
        minBanner.innerHTML = '<div class="fcp-min-banner__icon">✓</div><span>Minimum order met!</span>';
      } else {
        minBanner.classList.remove('fcp-min-banner--met');
        minBanner.innerHTML = '<div class="fcp-min-banner__icon">🚲</div><span>Minimum order size <strong>Rs 899</strong></span>';
      }
    }

        // Enable/disable checkout button — both min order AND time cutoff must pass
    const checkoutBtn = document.querySelector('.fcp-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.disabled = cart.total_price < 89900 || isOrderingClosed();
      checkoutBtn.style.opacity = checkoutBtn.disabled ? '0.5' : '';
    }

    // Update items total in bill
    document.querySelectorAll('.fcp-bill__row .fcp-bill__label').forEach(label => {
      if (label.textContent.includes('Items Total')) {
        label.closest('.fcp-bill__row').querySelector('span:last-child').textContent = fmt(cart.total_price);
      }
    });
  }

  // Stepper buttons
  document.querySelectorAll('.fcp-stepper').forEach(function(stepper) {
    stepper.addEventListener('click', async function(e) {
      const btn = e.target.closest('.fcp-stepper__btn');
      if (!btn) return;

      const key = this.dataset.key;
      const qtyEl = this.querySelector('.fcp-stepper__qty');
      let qty = parseInt(qtyEl.textContent);
      qty = btn.dataset.action === 'plus' ? qty + 1 : Math.max(0, qty - 1);

      // Optimistic UI update
      qtyEl.textContent = qty;
      btn.disabled = true;

      const cart = await updateCart(key, qty);
      btn.disabled = false;

      if (qty === 0) {
        const itemEl = this.closest('.fcp-item');
        itemEl.style.transition = 'opacity 0.3s';
        itemEl.style.opacity = '0';
        setTimeout(() => itemEl.remove(), 300);
      }

      await refreshCartTotals(cart);
    });
  });

  // Remove buttons
  document.querySelectorAll('.fcp-item__remove').forEach(function(btn) {
    btn.addEventListener('click', async function() {
      const key = this.dataset.key;
      const itemEl = this.closest('.fcp-item');
      itemEl.style.transition = 'opacity 0.3s';
      itemEl.style.opacity = '0.3';

      const cart = await updateCart(key, 0);
      setTimeout(() => itemEl.remove(), 300);
      await refreshCartTotals(cart);
    });
  });
  // Empty cart — intercept form submit, use AJAX
var emptyClearBtn = document.querySelector('button[name="clear"][value="true"]');
if (emptyClearBtn) {
  emptyClearBtn.closest('form').addEventListener('submit', function (e) {
    e.preventDefault();
    emptyClearBtn.disabled = true;
    emptyClearBtn.textContent = 'Clearing...';
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[fp-cart-page] clear error', err);
        emptyClearBtn.disabled = false;
        emptyClearBtn.textContent = '🗑 EMPTY CART';
      });
  });
}
  /* ── TIME-BASED CHECKOUT CUTOFF (IST) ── */
  var CUTOFF_HOUR = 23;   // 11 PM IST — orders close
  var OPEN_HOUR   = 6;    // 6 AM IST — orders reopen

    function getISTHour() {
    var now = new Date();
    // IST = UTC + 5:30 — always calculate from UTC directly
    var utcMs = now.getTime() + (now.getTimezoneOffset() * 60 * 1000);
    var istMs = utcMs + (5.5 * 60 * 60 * 1000);
    return new Date(istMs).getHours();
  }

  function isOrderingClosed() {
    var h = getISTHour();
    return h >= CUTOFF_HOUR || h < OPEN_HOUR;
  }

  function applyTimeCutoff() {
    var btn = document.querySelector('.fcp-checkout-btn');
    var note = document.querySelector('.fcp-checkout-note');
    if (!btn) return;

    if (isOrderingClosed()) {
      btn.disabled = true;
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
      if (note) {
        note.style.color = '#e53e3e';
        note.style.fontWeight = '700';
        note.textContent = '🌙 Ordering closed for tonight. Opens at 6 AM IST.';
      }
    } else {
      // Only re-enable if min order is also met — don't override that check
      var total = 0;
      var leftEl = btn.querySelector('.fcp-checkout-btn__left');
      if (leftEl) {
        total = parseFloat(leftEl.textContent.replace(/[^0-9.]/g, '')) * 100;
      }
      if (total >= 89900) {
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.cursor = '';
      }
      if (note) {
        note.style.color = '';
        note.style.fontWeight = '';
        note.textContent = '**No Questions asked Refunds or Returns';
      }
    }
  }

  // Run on load
  applyTimeCutoff();

  // Re-check every minute (handles edge case of page staying open across cutoff)
  setInterval(applyTimeCutoff, 60 * 1000);

  /* ── CART:UPDATED from recommendation cards ── */
  document.addEventListener('cart:updated', function(e) {
    var cart = e.detail;
    if (cart && cart.items) refreshCartTotals(cart);
  });

})();
